import React, {  useEffect } from 'react';
// import { NavLink } from 'react-router-dom'
import {FaArrowUp} from 'react-icons/fa'
import { useRecoilState } from 'recoil';
import Wave from './Wave';
import {buttonTop} from '../../store'
import { Link } from 'react-router-dom';

import {FaWhatsapp, FaInfoCircle} from 'react-icons/fa'



function Footer() {
  const [showScroll, setShowScroll] = useRecoilState(buttonTop)

  const checkScrollTop = () => {
    if (!showScroll && window.scrollY > 40){
      setShowScroll(true)
    } else if (showScroll && window.scrollY <= 40){
      setShowScroll(false)
    }
  }

  const scrollTop = () =>{
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  window.addEventListener('scroll', checkScrollTop)

  useEffect(() => {
   scrollTop()
  }, [])

 

  return (
    <div>
      <button
        onClick={scrollTop}
        className="fixed bottom-0 right-0 justify-items-stretch w-12 h-12 mr-5 mb-5 bg-black text-white bg-opacity-75 hover:bg-gray-300 hover:text-black rounded-full flex items-center justify-center shadow transition ease-in duration-200 focus:outline-none"
        style={{ display: showScroll ? "flex" : "none" }}
      >
        <FaArrowUp className="justify-self-auto " />
      </button>

      <Wave warna1="#e4e7eb" warna2="#ffff" />

      <footer className="bg-white">
        <div className="container mx-auto px-8">
          <div className="w-full flex flex-col md:flex-row py-6">
            <div className="flex-1 mb-6 text-black">
              <a
                className="text-pink-600 no-underline hover:no-underline font-bold text-2xl lg:text-4xl"
                href="/"
              >
                <img
                  src="/assets/images/logo-kehati.png"
                  className="w-2/3"
                  alt="Kehati Kaltim"
                />
              </a>
            </div>
            <div className="flex-1">
              <p className="uppercase text-teal-700 font-semibold md:mb-6">
                Link Terkait
              </p>
              <ul className="list-reset mb-6">
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="https://kaltimprov.go.id/"
                    className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                  >
                    Pemprov Kalimantan Timur
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="https://dinaslh.kaltimprov.go.id/"
                    className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                  >
                    DLH Kalimantan Timur
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="https://sparkling.kaltimprov.go.id/"
                    className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                  >
                    SPARKLING
                  </a>
                </li>
              </ul>
            </div>
            <div className="flex-1">
              <p className="uppercase text-teal-700 font-semibold md:mb-6">
                Database Kehati
              </p>
              <ul className="list-reset mb-6">
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <Link
                    to="/database/fauna"
                    className="no-underline hover:underline text-gray-800 hover:text-orange-500"
                  >
                    Fauna
                  </Link>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <Link
                    to="/database/flora"
                    className="no-underline hover:underline text-gray-800 hover:text-orange-500"
                  >
                    Flora
                  </Link>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <Link
                    to="/database/ekosistem"
                    className="no-underline hover:underline text-gray-800 hover:text-orange-500"
                  >
                    Ekosistem
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex-1">
              <p className="uppercase text-teal-700 font-semibold md:mb-6">
                Social Media
              </p>
              <ul className="list-reset mb-6">
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="/"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Facebook
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="/"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Instagram
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="/"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    YouTube
                  </a>
                </li>
              </ul>
            </div>
            <div className="flex-1">
              <p className="uppercase text-gray-500 md:mb-6">KEHATI KALTIM</p>
              <ul className="list-reset mb-6">
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <Link
                    to="/disclaimer"
                    className="no-underline hover:underline text-gray-800 hover:text-orange-500"
                  >
                    <FaInfoCircle className="inline-table mb-0.5" /> Disclaimer
                  </Link>
                </li>

                <li className="mt-5 block md:inline-block mr-2 md:block md:mr-0">
                  <a
                    href="https://wa.me/628115841546?text=Hallo%20Team%20Kehati%2C%20saya%20ingin%20bertanya%20"
                    target="_blank"
                    rel="noreferrer"
                    className="no-underline border rounded-lg font-semibold border-teal-500 bg-teal-500 hover:bg-teal-700 px-3 py-3 text-white transition-all"
                  >
                    <FaWhatsapp className="inline-table mb-0.5" /> Hubungi Kami
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-center py-5 px-5 text-center">
          <a
            href="https://dinaslh.kaltimprov.go.id/"
            className="text-gray-500 hover:text-teal-700 "
          >
            Copyright &copy; Dinas Lingkungan Hidup Provinsi Kalimantan Timur
          </a>
        </div>
      </footer>
    </div>
  );
}

export default Footer;